module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container",
    class: {
      prepend: _vm.addon
    }
  }, [_c('label', {
    staticClass: "label-default pl-caption"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), (_vm.addon) ? _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('i', {
    staticClass: "fas input-group-text",
    class: ("fa-" + _vm.addon)
  })]) : _vm._e(), _vm._v(" "), _c('input', _vm._g(_vm._b({
    ref: "input-native-tag",
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    class: [
      _vm.centeredText ? 'tc' : null,
      _vm.hasError,
      _vm.customStyle ?
      _vm.customStyle :
      'bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded' ],
    attrs: {
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }, 'input', _vm.$attrs, false), _vm.listeners)), _vm._v(" "), _c('span', {
    staticClass: "error-message pl-caption"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1dba68bf!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plInput/plInput.vue
// module id = 2362
// module chunks = 61